import React, { Component } from 'react';
import { debounce } from 'lodash';

class Search extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchString: ''
    };

    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.search = debounce(this.search, 160);
  }

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      window.location.href = '/search?search=' + this.state.searchString;
    }
  }

  onKeyUp(event) {
    this.setState({ searchString: event.target.value }, () => {
      let url = '/search/json?search=' + this.state.searchString + '&_format=json';
      if (this.state.searchString.length >= 2) {
        this.search(url, true);
      }
    });
  }

  search (queryString, initialLoad = false) {

    fetch(queryString, {
      method: 'GET',
      credentials: 'same-origin'
    })
    .then(response => response.json())
    .then(data => {
      this.props.onSearch(data, this.state.searchString);
    })
  }

  render() {
    return (
      <div className="search-input-container overlay-content--top">
        <input
          type="text"
          className="search-input"
          onKeyUp={this.onKeyUp}
          onKeyPress={this.handleKeyPress}
          placeholder="Search"
          tabIndex="-1"
          title="Site Search"
          name="search"
        />
        <i className="search-icon-black"></i>
      </div>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/Search.js